import { render, staticRenderFns } from "./chat-reaction.vue?vue&type=template&id=1bbeea22&scoped=true&lang=pug"
import script from "./chat-reaction.vue?vue&type=script&lang=js"
export * from "./chat-reaction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bbeea22",
  null
  
)

export default component.exports